var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDwg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7361AB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_807_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.3,329.8H97.2v49.9h11.1c5.5,0,9.8-1.8,13-5.5c3.2-3.7,4.8-8.4,4.8-14.2v-10.4   c0-5.7-1.6-10.4-4.8-14.1C118.1,331.6,113.8,329.8,108.3,329.8z",
    id: "XMLID_816_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,285.9H40.3v133.9h276.3L365.6,285.9z M137.5,359.9c0,8.5-2.7,15.4-8.1,20.8   c-5.4,5.4-12.4,8-21.1,8H85.9v-68h22.5c8.6,0,15.6,2.7,21.1,8.1c5.4,5.4,8.1,12.3,8.1,20.8V359.9z M211.4,388.7h-10.3l-13.6-48.4   h-0.3l-13.6,48.4h-10.4l-16.1-68H159l10.1,49h0.3l12.9-49h10l13,49.1h0.3l10-49.1h12L211.4,388.7z M289.4,379.5   c-1.9,2.6-4.9,5-8.9,7.1c-4.1,2.1-9.4,3.1-15.9,3.1c-8,0-14.6-2.6-19.8-7.8c-5.2-5.2-7.8-11.9-7.8-20.1v-14.2   c0-8.2,2.5-14.9,7.5-20.1c5-5.2,11.5-7.8,19.3-7.8c7.9,0,14.1,2,18.5,6c4.4,4,6.6,9.2,6.4,15.6l-0.1,0.3h-10.8   c0-3.8-1.2-6.9-3.6-9.3s-5.8-3.5-10.3-3.5c-4.7,0-8.5,1.8-11.4,5.3c-2.9,3.5-4.3,8-4.3,13.4v14.3c0,5.5,1.5,10,4.5,13.5   c3,3.5,6.9,5.3,11.8,5.3c3.6,0,6.5-0.4,8.6-1.2c2.1-0.8,3.7-1.8,4.8-3v-14.1h-14.3v-8.5h25.6V379.5z",
    id: "XMLID_811_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.9,6L352.9,6L107.4,6c-7.3,0-13.3,6-13.3,13.3v256.8h26.6V32.6h232.2v92.2h92.2v354.6   H120.7v-49.8H94.1v63.1c0,7.3,6,13.3,13.3,13.3h351c7.3,0,13.3-6,13.3-13.3V124.8L352.9,6z",
    id: "XMLID_810_"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 19.6,
    id: "XMLID_809_",
    width: 253.4,
    x: 156.2,
    y: 171.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 19.6,
    id: "XMLID_808_",
    width: 213.3,
    x: 156.2,
    y: 209.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwg);
export default __webpack_public_path__ + "static/media/dwg.814162ea96c207bb29cfe31d74cee849.svg";
export { ForwardRef as ReactComponent };